module.exports = __webpack_public_path__ + "static/media/Grid.4b16f476.PNG";